<template>
  <NavList :nav-items="navItems" />
</template>

<script>
import NavList from './NavList';

export default {
  name: 'RetailerProductsNavList',
  components: {
    NavList,
  },
  data() {
    return {
      navItems: [
        {
          text: 'PRODUCTS',
          header: true,
          requireSystemUser: true,
          requireAccountType: ['Retailer'],
          requirePagePermission: 'retailerTagging',
          requireSystemPermission: 'hasDataManagement',
        },
        {
          text: 'Tagging',
          icon: 'tag',
          route: '/product/tagging',
          requireSystemUser: true,
          requireAccountType: ['Retailer'],
          requirePagePermission: 'retailerTagging',
          requireSystemPermission: 'hasDataManagement',
        },
      ],
    };
  },
};
</script>
